import { REPORTING_CHARGEBACK } from '../actionTypes';

export const fetchChargebackReporting = (payload) => ({
  type: REPORTING_CHARGEBACK.FETCH,
  payload,
});
